/**
 * EM-UPSELL
 * =========
 * Auswahl und Reihenfolge der Upsell-Vorschlaege im Warenkorb-Drawer
 * (sections/mr-vue-cart.liquid). Reine Funktionen ohne DOM-Zugriff, damit
 * sich die Bewertung isoliert testen und nachjustieren laesst.
 *
 * Jeder Kandidat bekommt zwei Teilwerte (je 0-10):
 *
 *   Thema  - wie gut passt das Produkt zum Warenkorb?
 *            Metafeld "Passt dazu" (aus den Kaufdaten, Rang 1 = 10 Punkte,
 *            je Rang -0,6), +1 je weiterem Warenkorb-Produkt, das es ebenfalls
 *            vorschlaegt, +1 bei gleichem Produkttyp (Warengruppe) wie ein
 *            Warenkorb-Produkt. Shopify-Empfehlungen (Rueckfall): 3 Punkte,
 *            Lueckenfueller aus dem Theme-Editor: 1 Punkt.
 *
 *   Preis  - wie gut schliesst das Produkt die Luecke bis zur naechsten
 *            Schwelle (Geschenk oder Gratisversand)?
 *            schliesst sie mit hoechstens 30 % Ueberschuss:     10
 *            mehr Ueberschuss: bis zum Doppelten der Luecke     10 -> 4
 *                              bis zum Dreifachen                4 -> 0
 *            schliesst sie nicht: anteilig                       8 x Preis/Luecke
 *            Ohne Luecke (alles erreicht, B2B) zaehlt nur das Thema.
 *
 * Bei Produkten mit mehreren Varianten wird die Variante mit dem besten
 * Preiswert vorgewaehlt (z. B. 1 L statt 5 L).
 */
(function () {
  'use strict';

  var WEIGHTS = {
    metafieldTop: 10,      // Thema fuer Rang 1 im Metafeld
    metafieldStep: 0.6,    // Abzug je Rang
    metafieldMin: 4,       // Untergrenze fuer hintere Raenge
    multiSource: 1,        // je weiterem Warenkorb-Produkt mit demselben Vorschlag
    sameType: 1,           // gleicher Produkttyp wie ein Warenkorb-Produkt
    fallback: 3,           // Shopify-Empfehlung
    filler: 1,             // Lueckenfueller
    maxTheme: 10
  };

  function priceScore(price, gap) {
    if (!(gap > 0) || !(price > 0)) return 0;
    if (price < gap) return 8 * price / gap;
    var over = (price - gap) / gap;
    if (over <= 0.3) return 10;
    if (over <= 1) return 10 - 6 * (over - 0.3) / 0.7;
    if (over <= 2) return 4 - 4 * (over - 1);
    return 0;
  }

  // Beste kaufbare Variante fuer die Luecke (ohne Luecke: die erste kaufbare).
  function bestVariant(product, gap, excludeVariantIds) {
    var best = null;
    var bestScore = -1;
    (product.variants || []).forEach(function (v) {
      if (!v.available || !(v.price > 0) || excludeVariantIds[String(v.id)]) return;
      var score = priceScore(v.price, gap);
      if (score > bestScore) { best = v; bestScore = score; }
    });
    return best;
  }

  /**
   * @param {Object} input
   *   sources            [{ product_id, type, recs: [product] }]  Warenkorb-Produkte (ohne Geschenke)
   *   fallback           [product]  Shopify-Empfehlungen
   *   fillers            [product]  Lueckenfueller
   *   excludeProductIds  [id]       z. B. Warenkorb-Produkte, Geschenk-Produkte
   *   excludeVariantIds  [id]       z. B. Geschenk-Varianten (Tester einer normalen Creme)
   *   excludeTag         'kein-upsell'
   *   gap                Cent bis zur naechsten Schwelle (0 = keine)
   *   maxCards           Anzahl Vorschlaege
   * product = { id, handle, title, type, tags, available, image, variants: [{ id, title, price, compare_at_price, available, image }] }
   * @returns [{ product, variant, theme, price, total, closesGap, highlight }]
   */
  function rank(input) {
    var gap = input.gap > 0 ? input.gap : 0;
    var excludeProducts = {};
    (input.excludeProductIds || []).forEach(function (id) { excludeProducts[String(id)] = true; });
    var excludeVariants = {};
    (input.excludeVariantIds || []).forEach(function (id) { excludeVariants[String(id)] = true; });
    var excludeTag = String(input.excludeTag || '').toLowerCase();
    var cartTypes = {};
    (input.sources || []).forEach(function (s) { if (s.type) cartTypes[s.type] = true; });

    var candidates = {};
    function consider(product, theme, sourceId) {
      if (!product || product.available === false) return;
      var id = String(product.id);
      if (excludeProducts[id]) return;
      if (excludeTag && (product.tags || []).some(function (t) { return String(t).toLowerCase() === excludeTag; })) return;
      var c = candidates[id];
      if (!c) {
        c = candidates[id] = { product: product, theme: theme, sources: {} };
      } else if (theme > c.theme) {
        c.theme = theme;
      }
      if (sourceId) c.sources[sourceId] = true;
    }

    (input.sources || []).forEach(function (s) {
      (s.recs || []).forEach(function (p, index) {
        var theme = Math.max(WEIGHTS.metafieldMin, WEIGHTS.metafieldTop - WEIGHTS.metafieldStep * index);
        consider(p, theme, String(s.product_id));
      });
    });
    (input.fallback || []).forEach(function (p) { consider(p, WEIGHTS.fallback, null); });
    (input.fillers || []).forEach(function (p) { consider(p, WEIGHTS.filler, null); });

    var result = [];
    Object.keys(candidates).forEach(function (id) {
      var c = candidates[id];
      var variant = bestVariant(c.product, gap, excludeVariants);
      if (!variant) return;
      var extraSources = Math.max(0, Object.keys(c.sources).length - 1);
      var theme = c.theme + WEIGHTS.multiSource * extraSources + (cartTypes[c.product.type] ? WEIGHTS.sameType : 0);
      theme = Math.min(WEIGHTS.maxTheme, theme);
      var price = priceScore(variant.price, gap);
      result.push({
        product: c.product,
        variant: variant,
        theme: theme,
        price: price,
        total: theme + price,
        closesGap: gap > 0 && variant.price >= gap,
        // Etikett "Sichert dir ..." nur, wenn der Preis nicht weit ueber der Luecke liegt.
        highlight: gap > 0 && variant.price >= gap && variant.price <= 2 * gap
      });
    });

    result.sort(function (a, b) {
      return (b.total - a.total) || (b.theme - a.theme) || (a.variant.price - b.variant.price);
    });
    return result.slice(0, input.maxCards > 0 ? input.maxCards : 6);
  }

  window.EMUpsell = { rank: rank, priceScore: priceScore, bestVariant: bestVariant, WEIGHTS: WEIGHTS };
})();
